module.exports = __webpack_public_path__ + "static/media/eco.034eade5.svg";